import { render, staticRenderFns } from "./ChatterImport.vue?vue&type=template&id=05d64c08"
import script from "./ChatterImport.vue?vue&type=script&lang=js"
export * from "./ChatterImport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports